<div style="min-height:90px;"></div>
<div class="w-3/4 m-auto bg-white box-shadow-pop" style="border-radius: 20px">
  <ticket-view (outputOpenCustomerEvent)="openCustomerPage($event)"  [setNotesEditable]="false"  [ticketId]="ticketId"></ticket-view>
</div>
